import * as React from "react";
import { Box } from "@mui/material";
import { DataGridPremium, GridColDef } from "@mui/x-data-grid-premium";
import { MiscWorkRecord } from "../miscWorkData";

export type WorkEntriesProps = {
    record: MiscWorkRecord;
};

function getDateFromTimestamp(date: string) {
    if (!date) {
        return "";
    }
    return new Date(date).toLocaleDateString();
}

function getCurrency(value: number) {
    return value.toLocaleString("en-US", { style: "currency", currency: "USD" });
}

const WorkEntries: React.FC<WorkEntriesProps> = (props) => {
    const columns: GridColDef[] = [
        {
            field: "workDate",
            headerName: "Work Date",
            valueGetter: (params) => getDateFromTimestamp(params.row.workDate),
            width: 150,
        },
        { field: "description", headerName: "Description", flex: 1, minWidth: 240 },
        { field: "hours", headerName: "Hours", type: "number", width: 120 },
        {
            field: "rate",
            headerName: "Rate",
            valueGetter: (params) => getCurrency(params.row.rate),
            width: 120,
        },
        {
            field: "amount",
            headerName: "Amount",
            valueGetter: (params) => getCurrency(params.row.amount),
            width: 130,
        },
    ];

    return (
        <Box sx={{ width: 1, height: 1, p: 1 }}>
            <DataGridPremium
                columns={columns}
                rows={props.record.entries}
                getRowId={(row) => row.id}
                hideFooter={props.record.entries.length <= 25}
                disableSelectionOnClick
            />
        </Box>
    );
};

export default WorkEntries;